<div class="domain-for-sale-list-container">
    <ul class="p-2">
        <li *ngFor="let domain of domainForSaleList">{{ domain }}</li>
    </ul>
</div>
